// eslint-disable-next-line camelcase
import { AppProvider } from 'app/context/app-context';
import { AuthProvider } from 'app/context/auth-context';
import { AutoLogoutProvider } from 'app/context/AutoLogoutProvider';
import { useAxiosInterceptor } from 'app/context/axiosInterceptors';
import { S3ObjectProvider } from 'app/context/S3ObjectContext';
import { Routes } from 'app/routing/Routes';
import { Amplify } from 'aws-amplify';
import axios, { AxiosError } from 'axios';
import axiosRetry from 'axios-retry';
import React, { Suspense } from 'react';
import { BrowserRouter } from 'react-router-dom';

import { I18nProvider } from '../_metronic/i18n/i18nProvider';
import { LayoutProvider, LayoutSplashScreen } from '../_metronic/layout/core';

Amplify.configure({
  Auth: {
    region: process.env.REACT_APP_AWS_REGION || 'us-east-1',
    identityPoolId:
      process.env.REACT_APP_IDENTITY_POOL_ID || 'us-east-1:affd39c2-3223-4960-bb06-a66871594b49',
    userPoolId: process.env.REACT_APP_USER_POOL_ID || 'us-east-1_0tTacVYXu',
    userPoolWebClientId:
      process.env.REACT_APP_USER_POOL_WEB_CLIENT_ID || 'n0l61t9dq6pqpnsh14bksh21a',
    mandatorySignIn: false
  },
  Storage: {
    AWSS3: {
      region: process.env.REACT_APP_AWS_REGION || 'us-east-1',
      bucket: process.env.REACT_APP_S3_BUCKET || 'videojobfairs-docs-stage'
    }
  }
});

// intercept
axiosRetry(axios, {
  retries: 3,
  retryCondition: (error: AxiosError) => {
    return (
      axiosRetry.isNetworkError(error) ||
      axiosRetry.isRetryableError(error) ||
      error.response?.status === 429
    );
  },
  retryDelay: axiosRetry.exponentialDelay
});

type Props = {
  basename: string;
};

const App: React.FC<Props> = ({ basename }) => {
  useAxiosInterceptor();
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <BrowserRouter basename={basename}>
        <I18nProvider>
          <LayoutProvider>
            <AppProvider>
              <AuthProvider>
                <S3ObjectProvider>
                  <AutoLogoutProvider
                    timeoutDuration={20 * 60 * 1000} // 20 minutes
                    warningDuration={2 * 60 * 1000} // 2 minutes warning
                    enabled={true}
                  >
                    <Routes />
                  </AutoLogoutProvider>
                </S3ObjectProvider>
              </AuthProvider>
            </AppProvider>
          </LayoutProvider>
        </I18nProvider>
      </BrowserRouter>
    </Suspense>
  );
};

export { App };
